import { render, staticRenderFns } from "./Idle.vue?vue&type=template&id=be56c69c&scoped=true&"
import script from "./Idle.vue?vue&type=script&lang=js&"
export * from "./Idle.vue?vue&type=script&lang=js&"
import style0 from "./Idle.vue?vue&type=style&index=0&id=be56c69c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be56c69c",
  null
  
)

export default component.exports